import React from 'react';
import MetaHead from '@/components/MetaHead';
import Landing from '@/components/podercard/Landing';
import { useGetUrl } from '@/hooks/getUrl';
import { useTranslation } from '@/hooks/translation';
import { useCurrentUser } from '@/hooks/user';

export default function PoderCardPage() {
  const { isLoading: isUserLoading, user } = useCurrentUser();
  const { t } = useTranslation();
  const { rootUrl } = useGetUrl();
  const staticImageUrl = require('res/images/PODERcard.png').default.src;

  const imageUrl = `${rootUrl}${staticImageUrl}`;

  return (
    <>
      <MetaHead
        title={t('meta.podercard.title')}
        description={t('meta.podercard.description')}
        imageUrl={imageUrl}
        imageType="image/png"
        imageWidth='500'
        imageHeight='500'
      />
      <Landing
        isUserLoading={isUserLoading}
        user={user}
      />
    </>
  );
}
